import type { BdcRecoverableField } from "../../../exceptions/creditReportExceptions";

export interface DataValidationNavigationOptions {
  /** Contact review cannot repair backend-rejected identity or address data. */
  readonly requiresIdentityReview?: boolean;
}

// Backend prerequisite blockers and contact-review fields. Unknown fields must
// request identity review instead of being sent to contact-only confirmation.
const BDC_CONTACT_FIELDS = new Set([
  "nip_destination",
  "nip_email",
  "email",
  "phone_number",
  "dial_code",
  "nip_destination_reviewed",
  "nip_destination_dial_code",
]);

export function requiresIdentityReviewForBdcFields(
  fields: readonly BdcRecoverableField[],
): boolean {
  return fields.some(
    (field) =>
      field.target_slug === "data-validation" &&
      !BDC_CONTACT_FIELDS.has(field.field),
  );
}
